import { toast } from 'sonner'

/**
 * AppToast — Reusable shared toast wrapper
 *
 * Features:
 *  - Always dismisses the current toast before firing a new one so
 *    re-clicking the same action with the same message still re-triggers
 *    the toast (Sonner normally deduplicates same-content toasts).
 *  - Custom overrides for common application contexts.
 */
function resolveMessage(msg) {
  if (!msg) return ''
  if (typeof msg === 'string') return msg
  if (typeof msg === 'object') {
    return msg.message || msg.detail || msg.error || JSON.stringify(msg)
  }
  return String(msg)
}

export const appToast = {
  success: (message, description = '', options = {}) => {
    toast.dismiss()
    toast.success(resolveMessage(message), {
      description: resolveMessage(description),
      ...options,
    })
  },
  error: (message, description = '', options = {}) => {
    toast.dismiss()
    toast.error(resolveMessage(message), {
      description: resolveMessage(description),
      ...options,
    })
  },
  warning: (message, description = '', options = {}) => {
    toast.dismiss()
    toast.warning(resolveMessage(message), {
      description: resolveMessage(description),
      ...options,
    })
  },
  info: (message, description = '', options = {}) => {
    toast.dismiss()
    toast.info(resolveMessage(message), {
      description: resolveMessage(description),
      ...options,
    })
  },
}
